import * as React from 'react'
import MUICardContent from '@mui/material/CardContent'

const CardContent = (props) => <MUICardContent {...props} />

export default CardContent
